import { Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, Renderer2 } from '@angular/core';
import { GenericConfig, RestUrlsConfig } from '@signature-it/ngx-generic/config';

declare let _: any;
declare let $: any;

@Directive({
    selector: '[no-image]',
    standalone: false
})
export class NoImageDirectiveGeneric implements OnChanges, OnDestroy {
    listenError: Function;
    protected _conf: object;
    protected _sizesList: string[] = ['Sma', 'Med', 'Big', 'Enlarge', 'Dim', 'DimTech', 'Tech2', 'Tech1'];
    protected _size: string;
    protected _src: string;
    protected extensionIndex: number = 1;
    @Input('size') set size(size: string) {
        this._size = this._sizesList.indexOf(size) > -1 ? size : this._sizesList[0];
    }

    @Input() multiExtension = null
    get size() {
        return !_.isEmpty(this._size) ? this._size : this._sizesList[0];
    }
    @Input('src') set src(src: string) {
        const imgEl = this.el.nativeElement;
        this.renderer.setAttribute(imgEl, 'src', src);
        this.listenError = this.renderer.listen(imgEl, 'error', this.onError.bind(event, this));
    }
    CDNPrefix = GenericConfig.CDNPrefix || '';

    constructor(protected restUrlsConf: RestUrlsConfig,
                protected el: ElementRef,
                protected renderer: Renderer2) {
        this._conf = GenericConfig;
    }

    ngOnChanges(changes: SimpleChanges): void {

    }

    onError(self, {target}) {
        const imgEl = self.el.nativeElement;
        if($(target).attr('src') !== self.getNoImagePic()) {
            if(self.multiExtension && self.extensionIndex < self.multiExtension.length) {
                let imageSrc = $(target).attr('src').replace(/\.(\w*)/, `.${self.multiExtension[self.extensionIndex++]}`);
                self.renderer.setAttribute(target, 'src', imageSrc);
            } else {
                self.renderer.setAttribute(target, 'src', self.getNoImagePic());
                self.renderer.setAttribute(imgEl, 'alt', "No Image");
            }
        }
    }
    
    getNoImagePic() {
        let image = `${GenericConfig.noImagePic}`.replace(/{size}/, this.size);
        return `${this.CDNPrefix}${image}`;
    }

    ngOnDestroy() {
        if(this.listenError instanceof Function) {
            this.listenError();
        }
    }

}
